<template>
    <!--header开始-->
	<header>
		<div class="top">
			<label class="fr">欢迎光临</label>
		</div>
		<div class="banner">
			<div class="blog">
				<div class="title">
					<label class="name">柴桑木子</label><label class="tag">blog</label><br>
					<label class="desc">神不足惧，死不足忧，祸苦易忍，福乐易求。</label>
				</div>
			</div>
		</div>
		<div class="nav">
			<nav>
				<a href="index.html" v-bind:class="{ action: index == 1 }">聚光灯下</a>
				<a href="jotting.html" v-bind:class="{ action: index == 2 }">心随笔动</a>
				<a href="article.html" v-bind:class="{ action: index == 3 }">浮云流水</a>
				<a href="technology.html" v-bind:class="{ action: index == 4 }">曲径通幽</a>
				<a href="aboutme.html" v-bind:class="{ action: index == 5 }">轻推门楹</a>
			</nav>
		</div>
	</header>
	<!--header结束-->
</template>

<script>
export default {
	name : 'HeaderBox',
	props: ['index'],
    data () {
        return {

        }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/HeaderBox.vue